@if (stores(); as stores) {
  <section class="centered-with-padding pb-16 pt-7">
    @if (data.title; as title) {
      <div class="mb-6">
        <app-title [title]="{ text: title, as: 'h1' }" size="h1" />
      </div>
    }
    <div class="grid grid-cols-1 items-stretch gap-3 desk:grid-cols-3">
      @for (store of stores; track store.uuid; let i = $index) {
        <div class="flex h-full flex-col overflow-hidden rounded-[15px]">
          <div class="flex items-center justify-between gap-x-6 bg-anis px-6 py-[18px]">
            <span class="font-title text-[25px] leading-[26px] tracking-[-0.5px]">{{ store.name }}</span>
            <app-svg [height]="24" [width]="24" src="assets/icons/pin.svg" />
          </div>
          <div class="flex flex-1 flex-col bg-gray-light px-6 py-[18px]">
            <div class="grid grow grid-cols-[auto_1fr] gap-x-3 gap-y-5">
              <app-svg [height]="20" [width]="20" src="assets/icons/pin.svg" />
              <span class="font-bold">{{ store.streetName }} {{ store.zipcode }} {{ store.city }}</span>
              <app-svg [height]="20" [width]="20" src="assets/icons/phone.svg" />
              <a [href]="store.phone?.telLink" class="font-bold">{{ store.phone?.formatted }}</a>
              <app-svg [height]="20" [width]="20" src="assets/icons/hour.svg" />
              <div>
                @let displayData = storeDisplayData()[i]!;
                <div class="font-bold">
                  {{
                    displayData.operationalStatus
                      ? displayData.operationalStatus.message
                      : displayData.storeStatus?.isOpenToday
                        ? ("GLOBAL.STORE_OPEN_TODAY" | translate)
                        : ("GLOBAL.STORE_CLOSED_TODAY" | translate)
                  }}
                </div>
                @if (displayData.storeStatus?.isOpenToday && !displayData.operationalStatus) {
                  <div>{{ displayData.storeStatus?.hoursToday }}</div>
                }
              </div>
            </div>
            @if (store.url; as url) {
              <div class="mt-auto flex w-full justify-center pt-6">
                <app-button [url]="url" [label]="'COMPONENT.LISTING-MAGASIN.SEE_THIS_STORE' | translate" />
              </div>
            }
          </div>
        </div>
      }
    </div>
  </section>
}
